import React from 'react';

interface CustomToastProps {
  title: string;
  message: string;
  icon?: React.ReactNode;
}

export const CustomToast: React.FC<CustomToastProps> = ({ title, message, icon }) => {
  return (
    <div className="flex items-center space-x-3">
      {icon && <div className="flex-shrink-0">{icon}</div>}
      <div className="flex-1">
        <h4 className="font-semibold text-sm m-0">{title}</h4>
        <p className="text-xs opacity-80 m-0">{message}</p>
      </div>
    </div>
  );
}; 